import React, { ReactNode } from 'react';

import { SvgIcon } from '@infoods/lifebase-ui';
import AccessibilityNewRoundedIcon from '@mui/icons-material/AccessibilityNewRounded';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AssignmentIndRoundedIcon from '@mui/icons-material/AssignmentIndRounded';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import DateRangeRoundedIcon from '@mui/icons-material/DateRangeRounded';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import FolderOpenRoundedIcon from '@mui/icons-material/FolderOpenRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ImportContactsRoundedIcon from '@mui/icons-material/ImportContactsRounded';
import InsertChartOutlinedRoundedIcon from '@mui/icons-material/InsertChartOutlinedRounded';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import NewReleasesRoundedIcon from '@mui/icons-material/NewReleasesRounded';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import RocketOutlinedIcon from '@mui/icons-material/RocketOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import SpaOutlinedIcon from '@mui/icons-material/SpaOutlined';
import SportsBaseballOutlinedIcon from '@mui/icons-material/SportsBaseballOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';
import WorkOutlineRoundedIcon from '@mui/icons-material/WorkOutlineRounded';

import { ReactComponent as AvocadoBeanIcon } from '../../../assets/icons/avocado-bean-icon.svg';
import { ReactComponent as BarcodeIcon } from '../../../assets/icons/barcode-icon.svg';
import { ReactComponent as ChallengeChipIcon } from '../../../assets/icons/challenge-chip.svg';
import { ReactComponent as DashboardIcon } from '../../../assets/icons/dashboard-icon.svg';
import { ReactComponent as GroceryIcon } from '../../../assets/icons/grocery-food-icon.svg';
import { ReactComponent as InbodyScaleIcon } from '../../../assets/icons/inbody-scale.svg';
import { ReactComponent as KeyIcon } from '../../../assets/icons/key-icon.svg';
import { ReactComponent as LookingBodyIcon } from '../../../assets/icons/looking-body.svg';
import { ReactComponent as MenuBookIcon } from '../../../assets/icons/menu-book-icon.svg';
import { ReactComponent as MonitoringIcon } from '../../../assets/icons/monitoring-icon.svg';
import { ReactComponent as NutritionChipIcon } from '../../../assets/icons/nutrition-chip.svg';
import { ReactComponent as PillIcon } from '../../../assets/icons/pill-icon.svg';
import { ReactComponent as ScanIqChipIcon } from '../../../assets/icons/scan-iq-chip.svg';
import { ReactComponent as ServiceToolboxIcon } from '../../../assets/icons/service-toolbox-icon.svg';
import { ReactComponent as ThumbUpIcon } from '../../../assets/icons/thumb-up-icon.svg';
import {
  NAVIGATION_ICON,
  NavigationIconType,
} from '../../../constants/system/navigationIcons';

const NAVIGATION_ICON_MAP: Record<NavigationIconType, ReactNode> = {
  /** MUI icons */
  [NAVIGATION_ICON.ACCESSIBILITY_NEW]: <AccessibilityNewRoundedIcon />,
  [NAVIGATION_ICON.ACCOUNT_BALANCE_WALLET]: <AccountBalanceWalletOutlinedIcon />,
  [NAVIGATION_ICON.ASSIGNMENT]: <AssignmentOutlinedIcon />,
  [NAVIGATION_ICON.ASSIGNMENT_IND]: <AssignmentIndRoundedIcon />,
  [NAVIGATION_ICON.AS_PDF]: <PictureAsPdfRoundedIcon />,
  [NAVIGATION_ICON.ATTACH_MONEY]: <AttachMoneyOutlinedIcon />,
  [NAVIGATION_ICON.AUTO_STORIES]: <AutoStoriesOutlinedIcon />,
  [NAVIGATION_ICON.BACKUP_TABLE]: <BackupTableIcon />,
  [NAVIGATION_ICON.BAR_CHART]: <BarChartOutlinedIcon />,
  [NAVIGATION_ICON.BUSINESS]: <BusinessOutlinedIcon />,
  [NAVIGATION_ICON.BUSINESS_CENTER]: <BusinessCenterRoundedIcon />,
  [NAVIGATION_ICON.CHAT]: <ChatOutlinedIcon />,
  [NAVIGATION_ICON.DATE_RANGE]: <DateRangeRoundedIcon />,
  [NAVIGATION_ICON.DESCRIPTION]: <DescriptionOutlinedIcon />,
  [NAVIGATION_ICON.EMOJI_EVENTS]: <EmojiEventsOutlinedIcon />,
  [NAVIGATION_ICON.FOLDER_OPEN]: <FolderOpenRoundedIcon />,
  [NAVIGATION_ICON.HOME]: <HomeRoundedIcon />,
  [NAVIGATION_ICON.IMPORT_CONTACTS]: <ImportContactsRoundedIcon />,
  [NAVIGATION_ICON.INSERT_CHART]: <InsertChartOutlinedRoundedIcon />,
  [NAVIGATION_ICON.LEADERBOARD]: <LeaderboardOutlinedIcon />,
  [NAVIGATION_ICON.LIST_ALT]: <ListAltRoundedIcon />,
  [NAVIGATION_ICON.MANAGE_ACCOUNTS]: <ManageAccountsOutlinedIcon />,
  [NAVIGATION_ICON.NEW_RELEASES]: <NewReleasesRoundedIcon />,
  [NAVIGATION_ICON.PEOPLE_OUTLINE]: <PeopleOutlineRoundedIcon />,
  [NAVIGATION_ICON.PERCENT]: <PercentRoundedIcon />,
  [NAVIGATION_ICON.PLAY_ARROW]: <PlayArrowRoundedIcon />,
  [NAVIGATION_ICON.ROCKET]: <RocketOutlinedIcon />,
  [NAVIGATION_ICON.SCHOOL]: <SchoolOutlinedIcon />,
  [NAVIGATION_ICON.SETTINGS]: <SettingsRoundedIcon />,
  [NAVIGATION_ICON.SPA]: <SpaOutlinedIcon />,
  [NAVIGATION_ICON.SPORTS_BASEBALL]: <SportsBaseballOutlinedIcon />,
  [NAVIGATION_ICON.TIMELINE]: <TimelineOutlinedIcon />,
  [NAVIGATION_ICON.TRENDING_UP]: <TrendingUpRoundedIcon />,
  [NAVIGATION_ICON.VIDEO_LIBRARY]: <VideoLibraryOutlinedIcon />,
  [NAVIGATION_ICON.WORK]: <WorkOutlineRoundedIcon />,

  /** custom icons */
  [NAVIGATION_ICON.AVOCADO_BEAN]: <SvgIcon component={AvocadoBeanIcon} inheritViewBox />,
  [NAVIGATION_ICON.BARCODE]: <SvgIcon component={BarcodeIcon} inheritViewBox />,
  [NAVIGATION_ICON.DASHBOARD]: <SvgIcon component={DashboardIcon} inheritViewBox />,
  [NAVIGATION_ICON.GROCERY]: <SvgIcon component={GroceryIcon} inheritViewBox />,
  [NAVIGATION_ICON.INBODY_SCALE]: <SvgIcon component={InbodyScaleIcon} inheritViewBox />,
  [NAVIGATION_ICON.KEY]: <SvgIcon component={KeyIcon} inheritViewBox />,
  [NAVIGATION_ICON.LOOKING_BODY]: <SvgIcon component={LookingBodyIcon} inheritViewBox />,
  [NAVIGATION_ICON.MENU_BOOK]: <SvgIcon component={MenuBookIcon} inheritViewBox />,
  [NAVIGATION_ICON.MONITORING]: <SvgIcon component={MonitoringIcon} inheritViewBox />,
  [NAVIGATION_ICON.PILL]: <SvgIcon component={PillIcon} inheritViewBox />,
  [NAVIGATION_ICON.SERVICE_TOOLBOX]: (
    <SvgIcon component={ServiceToolboxIcon} inheritViewBox />
  ),
  [NAVIGATION_ICON.THUMB_UP]: <SvgIcon component={ThumbUpIcon} inheritViewBox />,

  /** solution icons, custom */
  [NAVIGATION_ICON.NUTRITION_CHIP]: (
    <SvgIcon component={NutritionChipIcon} inheritViewBox />
  ),
  [NAVIGATION_ICON.SCAN_IQ_CHIP]: <SvgIcon component={ScanIqChipIcon} inheritViewBox />,
  [NAVIGATION_ICON.CHALLENGE_CHIP]: (
    <SvgIcon component={ChallengeChipIcon} inheritViewBox />
  ),
};

export const getNavigationIcon = (icon: NavigationIconType | null): ReactNode => {
  if (!icon) return undefined;

  return NAVIGATION_ICON_MAP[icon];
};
